import { ReviewProps } from '../types'

const getReviewSchema = (review: ReviewProps) => ({
  '@type': 'Review',
  datePublished: review.submittedAt,
  description: review.comment,
  author: {
    '@type': 'Person',
    name: review.title,
  },
  reviewRating: {
    '@type': 'Rating',
    bestRating: 5,
    ratingValue: review.rating,
    worstRating: 1,
  },
})

export default getReviewSchema
